// Generated by go-ts-exporter. DO NOT EDIT.

export const defaultCollectionName = {
  DefaultOrganizationCollectionLabel: "Shared Collections",
  DefaultPersonalCollectionLabel: "Personal Collection",
  DefaultFavoritesCollectionLabel: "Starred",
} as const;

export type defaultCollectionName = typeof defaultCollectionName[keyof typeof defaultCollectionName];
